export enum AuthAction {
	AuthStateChanged = 'AuthStateChanged'
}


// WEBPACK FOOTER //
// ./src/phoenix/services/auth/auth-service.actions.ts